export default __webpack_public_path__ + "static/media/flag9.3e17eb29.png";